module.exports = __webpack_public_path__ + "static/media/location_on_selected.2abe1515.svg";